<template>
  <div class="variation-number-container d-flex align-center">
    <div class="variation-signal" :class="isPositive ? 'positive positive-number' : 'negative negative-number'">
      <span>{{ isPositive ? '+' : '-' }}</span>
    </div>
    <span :class="isPositive ? 'positive-number' : 'negative-number'">{{
      isCurrency ? `R$ ${localeString(value, localeNumber)}` : localeString(value, localeNumber)
    }}</span>
  </div>
</template>

<script>
import { localeString } from '@/config/helpers.js'

export default {
  name: 'VariationNumber',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    localeNumber: {
      type: Number,
      default: 0,
    },
    variant: {
      type: String,
      default: 'positive',
      validator: (value) => ['positive', 'negative'].includes(value),
    },
    isCurrency: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isPositive() {
      return this.variant === 'positive'
    },
  },
  methods: {
    localeString,
  },
}
</script>

<style lang="scss" scoped>
.variation-number-container {
  display: flex;
  flex-direction: row;
  gap: 6px;
  .variation-signal {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-family: 'Courier New', Courier, monospace;
      font-size: 16px;
      font-weight: 500;
    }
  }
  .positive {
    background-color: rgba(15, 201, 77, 0.2);
  }
  .negative {
    background-color: rgba(244, 127, 104, 0.2);
  }
  .positive-number {
    color: $verde-d20;
  }
  .negative-number {
    color: $vermelho-d20;
  }
}
</style>
